import { useEffect, useState } from "react";
import Buttons from "./components/Buttons";
import SqlEditor from "./components/SqlEditor";
import PredefinedQuery from "./components/PredefinedQuery";
import Table from "./components/Table";
import SqlTemplatesService from "@app/services/http/sql-templates.service";
import toast from "react-hot-toast";
import SaveIcon from "@app/icons/save";
import { openPortalDialog } from "@app/services/modal.service";
import SaveSqlQueryModal from "@app/components/save-sql-query-modal";

function SqlEditorManagement() {
  const [value, setValue] = useState("select * from customers;");
  const [rows, setRows] = useState<any[]>([]);
  const [headers, setHeaders] = useState<string[]>([]);
  const [query, setQuery] = useState("");
  const [csvData, setCSVData] = useState<any[]>([]);
  const [templates, setTemplates] = useState<any[]>([]);
  const [, setIsExecuteSuccess] = useState(false);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const response = await SqlTemplatesService.getList();

      if (response.data?.items) {
        setTemplates(response.data.items);
      }
    } catch (error: any) {
      // Handle error silently or show toast notification
      // console.error(error);
    }
  };

  const openSaveQueryModal = () => {
    openPortalDialog(SaveSqlQueryModal)
      .afterClosed()
      .subscribe(async (name) => {
        if (name) {
          try {
            await SqlTemplatesService.create({
              sqlTemplate: value,
              name: name,
            });

            await fetchTemplates();
            toast.success("Query saved successfully");
          } catch (error) {
            toast.error("Failed to save query");
          }
        }
      });
  };

  return (
    <div className="py-6 px-12">
      <div className="flex justify-between items-center">
        <div className="text-[#343C6A]">SQL Editor</div>
      </div>
      <div className="mt-6 rounded-xl bg-white py-6 px-5">
        {/* Content */}
        <div className="flex flex-wrap justify-center items-start w-full">
          <div className="w-full">
            <div className="flex flex-wrap justify-center items-start w-full">
              <div className="w-full lg:w-9/12">
                <div className="flex justify-end">
                  <button
                    onClick={openSaveQueryModal}
                    className="flex mb-3 text-white bg-[#5570F1] border-0 py-2 h-11 px-4 focus:outline-none hover:bg-[#5570F1] rounded-[8px] text-lg justify-center items-center disabled:bg-indigo-300"
                  >
                    <div className="pr-3">
                      <SaveIcon />
                    </div>
                    <div className="font-[14px]">Lưu</div>
                  </button>
                </div>
                <SqlEditor value={value} setValue={setValue} />
                <div className="flex w-full justify-end">
                  <Buttons
                    csvData={csvData}
                    setCSVData={setCSVData}
                    setQuery={setQuery}
                    setHeaders={setHeaders}
                    setRows={setRows}
                    value={value}
                    onExecuteSuccess={setIsExecuteSuccess}
                  />
                </div>
                <Table query={query} headers={headers} rows={rows} />
              </div>
              <div className="w-full lg:w-3/12">
                <PredefinedQuery
                  setValue={setValue}
                  templates={templates}
                  fetchTemplates={fetchTemplates}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SqlEditorManagement;
